import HttpClient from '@/utility/http-client';
import { Comment } from '@/models/comment';

export default {
    getComment(orderId: any, orderType: any) {
        if (orderType === 5) {
            return HttpClient.instance().get(`/api/quotation/${orderId}/comments/`);
        }
        return HttpClient.instance().get(`/api/order_comment/?OrderID=${orderId}&OrderType=${orderType}`);
    },

    addComment(comment: Comment) {
        if (comment.OrderType === 5) {
            return HttpClient.instance().post(`/api/quotation/${comment.OrderID}/comments/`, {
                content: comment.Comment,
                extra: {
                    media: comment.Media || 0,
                    file_name: (comment as any).FileName || '',
                }
            });
        }
        return HttpClient.instance().put(`/api/order_comment/`, comment);
    },
};